/**
 * Header Notification Banner
 * Handles showing/hiding the notification and storing user preference in cookies
 */

class HeaderNotification {
  constructor() {
    this.notificationBar = document.querySelector('#headerNotification');
    this.closeButton = this.notificationBar.querySelector('[data-notification-close]');
    this.checkMoreLink = this.notificationBar.querySelector('.header-notification__link');
    this.cookieName = 'header_notification_closed';
    this.cookieDuration = 7;
    
    if (!this.notificationBar) return;
    
    this.init();
  }

  init() {
    // Check if notification was previously closed
    /*
    if (this.getCookie(this.cookieName)) {
      this.hideNotification(false);
    } else {
      this.showNotification();
    }
    */
    this.handleCheckMore();

    // Add close button event listener
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.handleClose());
    }
  }

  handleCheckMore() {
    // Only handle the click if we're on the homepage
    if (window.location.pathname === '/' || window.location.pathname === '' || window.location.pathname === '/pages/homepage') {
      const carouselSection = document.querySelector('[data-rid="1680ab2b-cc41-4ead-9131-69c7706f8909"]');
      if (carouselSection) {
        carouselSection.id = "scientific-research";
      }

      // Add smooth scroll behavior to the link
      if (this.checkMoreLink) {
        this.checkMoreLink.addEventListener('click', (e) => {
          e.preventDefault();
          const targetSection = document.getElementById('scientific-research');
          if (targetSection) {
            targetSection.scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      }
    }
  }

  showNotification() {
    this.notificationBar.classList.remove('hidden');
    document.body.classList.add('has-notification-bar');
  }

  hideNotification(animate = true) {
    if (animate) {
      this.notificationBar.classList.add('hidden');
      setTimeout(() => {
        document.body.classList.remove('has-notification-bar');
      }, 300); // Match CSS transition duration
    } else {
      this.notificationBar.style.display = 'none';
      document.body.classList.remove('has-notification-bar');
    }
  }

  handleClose() {
    this.hideNotification(true);
    this.setCookie(this.cookieName, 'true', this.cookieDuration);
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  }

  getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderNotification();
  });
} else {
  new HeaderNotification();
}
